// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

import * as flatbuffers from 'flatbuffers';

import { FileThumbnailKindBuf } from '../file/file-thumbnail-kind-buf.js';


export class FileThumbnailBuf {
  bb: flatbuffers.ByteBuffer|null = null;
  bb_pos = 0;
  __init(i:number, bb:flatbuffers.ByteBuffer):FileThumbnailBuf {
  this.bb_pos = i;
  this.bb = bb;
  return this;
}

static getRootAsFileThumbnailBuf(bb:flatbuffers.ByteBuffer, obj?:FileThumbnailBuf):FileThumbnailBuf {
  return (obj || new FileThumbnailBuf()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
}

static getSizePrefixedRootAsFileThumbnailBuf(bb:flatbuffers.ByteBuffer, obj?:FileThumbnailBuf):FileThumbnailBuf {
  bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
  return (obj || new FileThumbnailBuf()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
}

kind():FileThumbnailKindBuf {
  const offset = this.bb!.__offset(this.bb_pos, 4);
  return offset ? this.bb!.readUint8(this.bb_pos + offset) : FileThumbnailKindBuf.Native64;
}

width():bigint {
  const offset = this.bb!.__offset(this.bb_pos, 6);
  return offset ? this.bb!.readUint64(this.bb_pos + offset) : BigInt('0');
}

height():bigint {
  const offset = this.bb!.__offset(this.bb_pos, 8);
  return offset ? this.bb!.readUint64(this.bb_pos + offset) : BigInt('0');
}

uri():string|null
uri(optionalEncoding:flatbuffers.Encoding):string|Uint8Array|null
uri(optionalEncoding?:any):string|Uint8Array|null {
  const offset = this.bb!.__offset(this.bb_pos, 10);
  return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
}

static startFileThumbnailBuf(builder:flatbuffers.Builder) {
  builder.startObject(4);
}

static addKind(builder:flatbuffers.Builder, kind:FileThumbnailKindBuf) {
  builder.addFieldInt8(0, kind, FileThumbnailKindBuf.Native64);
}

static addWidth(builder:flatbuffers.Builder, width:bigint) {
  builder.addFieldInt64(1, width, BigInt('0'));
}

static addHeight(builder:flatbuffers.Builder, height:bigint) {
  builder.addFieldInt64(2, height, BigInt('0'));
}

static addUri(builder:flatbuffers.Builder, uriOffset:flatbuffers.Offset) {
  builder.addFieldOffset(3, uriOffset, 0);
}

static endFileThumbnailBuf(builder:flatbuffers.Builder):flatbuffers.Offset {
  const offset = builder.endObject();
  builder.requiredField(offset, 10) // uri
  return offset;
}

static createFileThumbnailBuf(builder:flatbuffers.Builder, kind:FileThumbnailKindBuf, width:bigint, height:bigint, uriOffset:flatbuffers.Offset):flatbuffers.Offset {
  FileThumbnailBuf.startFileThumbnailBuf(builder);
  FileThumbnailBuf.addKind(builder, kind);
  FileThumbnailBuf.addWidth(builder, width);
  FileThumbnailBuf.addHeight(builder, height);
  FileThumbnailBuf.addUri(builder, uriOffset);
  return FileThumbnailBuf.endFileThumbnailBuf(builder);
}
}
